import { site } from './site'

export type LegalSection = { heading: string; paragraphs: string[] }

export type LegalDoc = {
  title: string
  updated: string
  intro: string
  sections: LegalSection[]
}

/** Ported word for word from v1 (src/components/Privacy.tsx and ToS.tsx, last updated 30 September 2026). */
export const privacyPolicy: LegalDoc = {
  title: 'Privacy Policy',
  updated: 'September 30, 2026',
  intro: `This site is run by ${site.fullName}, a virtual assistant based in the Philippines. This policy covers this portfolio site only, not the client sites linked from it.`,
  sections: [
    {
      heading: 'What is collected',
      paragraphs: [
        'The contact form collects your first and last name, your email address and your message. The site also uses Google Analytics, Google Tag Manager and Microsoft Clarity, which collect anonymous usage data such as pages visited, device type and how the page is used. Booking a call happens on Google Calendar, under Google’s own privacy policy.',
      ],
    },
    {
      heading: 'How it is used',
      paragraphs: [
        'Messages from the form go to my GoHighLevel account so I can reply to you. I use them only to respond to your enquiry and to work with you if you become a client. I do not sell your details. Analytics data is used only to understand and improve this site.',
      ],
    },
    {
      heading: 'How long it is kept',
      paragraphs: [
        'Contact details are kept only as long as needed to handle your enquiry or our working relationship. You can ask me to see, correct or delete your details at any time by emailing me.',
      ],
    },
    {
      heading: 'Contact',
      paragraphs: [`Questions about this policy: ${site.email}.`],
    },
  ],
}

export const termsOfService: LegalDoc = {
  title: 'Terms of Service',
  updated: 'September 30, 2026',
  intro: `This site is a portfolio of ${site.fullName}’s work as a GoHighLevel virtual assistant.`,
  sections: [
    {
      heading: 'Using this site',
      paragraphs: ['You are welcome to browse it and contact me through it. Please do not misuse the contact form or try to disrupt the site.'],
    },
    {
      heading: 'Work and payment',
      paragraphs: [
        'Every project is scoped and agreed in writing before work starts, including what will be delivered, the timeline and the fee. Nothing on this site is a binding offer on its own.',
      ],
    },
    {
      heading: 'Ownership',
      paragraphs: [
        'The written content and design of this site belong to me unless stated otherwise. Screenshots and linked sites belong to their respective clients and are shown with permission. Brand names and logos belong to their owners.',
      ],
    },
    {
      heading: 'Liability',
      paragraphs: [
        'This site is provided as is. I am not liable for any loss arising from use of this site or of the external sites it links to. Liability for client work is set out in the agreement for that project.',
      ],
    },
    {
      heading: 'Contact',
      paragraphs: [`Questions about these terms: ${site.email}.`],
    },
  ],
}
